// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3CQDu","Logo":"Toolbar_Logo__38ntU","DesktopOnly":"Toolbar_DesktopOnly__2M-ns"};